import { render, staticRenderFns } from "./PostSubmitElement.vue?vue&type=template&id=746859c8&scoped=true&"
import script from "./PostSubmitElement.vue?vue&type=script&lang=js&"
export * from "./PostSubmitElement.vue?vue&type=script&lang=js&"
import style0 from "./PostSubmitElement.vue?vue&type=style&index=0&id=746859c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746859c8",
  null
  
)

export default component.exports